const StepperIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.91016" cy="6" r="5.41016" stroke="#183883" />
      <circle cx="6" cy="6.08984" r="3" fill="#183883" />
    </svg>
  );
};
export default StepperIcon;
